/* LOST SXULZ theme JS */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    var m = document.getElementById('toast-msg');
    if (m) m.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._toastT);
    window._toastT = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  window.lsToast = toast;

  /* ---------- Mobile menu ---------- */
  var mobileOpen = false;
  window.lsToggleMobile = function () {
    mobileOpen = !mobileOpen;
    var menu = document.getElementById('mobile-menu');
    var ico = document.getElementById('ham-ico');
    if (menu) menu.classList.toggle('open', mobileOpen);
    if (ico) ico.innerHTML = '<use href="#' + (mobileOpen ? 'ico-x' : 'ico-menu') + '"/>';
  };

  /* ---------- Hero emblem 3D tilt ---------- */
  function bindEmblemTilt() {
    var wrap = document.getElementById('hero-emblem-wrap');
    var el = document.getElementById('hero-emblem-3d');
    if (!wrap || !el) return;
    function setRot(rx, ry) {
      el.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      el.style.setProperty('--ry', ry.toFixed(2) + 'deg');
    }
    window.addEventListener('mousemove', function (e) {
      var r = wrap.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var dx = (e.clientX - cx) / (window.innerWidth / 2);
      var dy = (e.clientY - cy) / (window.innerHeight / 2);
      setRot(-dy * 18, dx * 32);
    }, { passive: true });
    window.addEventListener('mouseleave', function () { setRot(0, 0); });
    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', function (e) {
        if (e.gamma == null || e.beta == null) return;
        var ry = Math.max(-32, Math.min(32, e.gamma * 0.9));
        var rx = Math.max(-18, Math.min(18, (e.beta - 45) * -0.3));
        setRot(rx, ry);
      });
    }
  }

  /* ---------- Cart badge ---------- */
  function setBagCount(n) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBagCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  /* ---------- Product page: size/variant picker + AJAX add ---------- */
  function bindProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var warn = form.querySelector('.size-warning');
    var sizeBtns = form.querySelectorAll('.size-btn');
    var needsSize = sizeBtns.length > 0;
    var chosen = !needsSize; // if no size options, ready immediately

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        sizeBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (idInput) idInput.value = btn.getAttribute('data-variant-id');
        chosen = true;
        if (warn) warn.classList.remove('show');
      });
    });

    function submitAdd(redirect) {
      if (needsSize && !chosen) {
        if (warn) warn.classList.add('show');
        return;
      }
      var body = new FormData(form);
      addBtn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          addBtn.removeAttribute('disabled');
          if (item && item.id) {
            refreshCart();
            if (redirect) { window.location.href = '/cart'; }
            else { toast('Added to bag: ' + (item.product_title || 'Item')); }
          } else {
            toast((item && item.description) || 'Could not add to bag');
          }
        })
        .catch(function () {
          addBtn.removeAttribute('disabled');
          toast('Could not add to bag');
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitAdd(false);
    });
    var buyBtn = form.querySelector('[data-buy]');
    if (buyBtn) buyBtn.addEventListener('click', function (e) { e.preventDefault(); submitAdd(true); });

    /* thumbnail swap */
    var main = document.getElementById('pd-main-img');
    form.closest('.section-product').querySelectorAll('.pd-thumb').forEach(function (th) {
      th.addEventListener('click', function () {
        var src = th.getAttribute('data-full');
        if (main && src) main.src = src;
        document.querySelectorAll('.pd-thumb').forEach(function (t) { t.classList.remove('active'); });
        th.classList.add('active');
      });
    });
  }

  /* ---------- Cart page: qty + remove via AJAX ---------- */
  function bindCartPage() {
    var page = document.getElementById('cart-page');
    if (!page) return;
    function change(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setBagCount(cart.item_count); window.location.reload(); })
        .catch(function () {});
    }
    page.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        change(line, qty);
      });
    });
    page.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        change(parseInt(btn.getAttribute('data-line'), 10), 0);
      });
    });
  }

  /* ---------- Community lightbox ---------- */
  function bindLightbox() {
    var gallery = document.querySelector('[data-lightbox-gallery]');
    var lb = document.querySelector('[data-lightbox]');
    var dataEl = document.getElementById('community-gallery-data');
    if (!gallery || !lb || !dataEl) return;
    var urls;
    try { urls = JSON.parse(dataEl.textContent).filter(Boolean); } catch (e) { urls = []; }
    if (!urls.length) return;
    var img = lb.querySelector('[data-lightbox-image]');
    var index = 0;

    function show(i) {
      index = (i + urls.length) % urls.length;
      if (img) img.src = urls[index];
    }
    function open(i) {
      show(i);
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('open');
      document.body.style.overflow = '';
    }

    gallery.querySelectorAll('[data-lightbox-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-lightbox-index'), 10) || 0);
      });
    });
    var closeBtn = lb.querySelector('[data-lightbox-close]');
    var prevBtn = lb.querySelector('[data-lightbox-prev]');
    var nextBtn = lb.querySelector('[data-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
    if (img) img.addEventListener('click', function (e) { e.stopPropagation(); });
    lb.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(index + 1);
      else if (e.key === 'ArrowLeft') show(index - 1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindEmblemTilt();
    bindProductForm();
    bindCartPage();
    bindLightbox();
    refreshCart();
  });
})();
